export default __webpack_public_path__ + "static/media/jntua-logo.0eb8cbed.png";